import { RefreshCw, Wrench } from 'lucide-react'
import { useT } from '../../hooks/useTranslation'

export default function ErrorPage({ onRetry, error }) {
  const t = useT()
  return (
    <div style={{
      background: '#0A0A0A',
      minHeight: '100dvh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 24,
      position: 'relative',
      overflow: 'hidden',
      textAlign: 'center',
    }}>
      {/* Glow — same as main app */}
      <div aria-hidden="true" style={{
        position: 'absolute', top: 0, right: 0,
        width: '92%', height: '52%',
        background: 'radial-gradient(ellipse at 100% 0%, rgba(220,75,15,0.72) 0%, rgba(195,58,10,0.38) 28%, rgba(160,40,5,0.14) 55%, transparent 75%)',
        pointerEvents: 'none',
      }} />

      <div style={{ position: 'relative', zIndex: 1, maxWidth: 320 }}>
        {/* Icon */}
        <div style={{
          width: 80, height: 80, borderRadius: 22, margin: '0 auto 28px',
          background: 'linear-gradient(135deg, rgba(255,107,53,0.15) 0%, rgba(249,115,26,0.08) 100%)',
          border: '1px solid rgba(255,107,53,0.2)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <Wrench size={38} color="#34D399" />
        </div>

        <h1 style={{ fontSize: 26, fontWeight: 800, color: '#fff', marginBottom: 10 }}>
          {t.maintenance}
        </h1>
        <p style={{ fontSize: 15, color: '#8E8E93', lineHeight: 1.65, marginBottom: 36 }}>
          {t.maintenanceDesc}
        </p>

        <button
          onClick={onRetry}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: 8,
            padding: '14px 32px', borderRadius: 14,
            background: 'linear-gradient(135deg, #34D399 0%, #10B981 100%)',
            color: '#fff', fontSize: 15, fontWeight: 700,
            border: 'none', cursor: 'pointer',
            boxShadow: '0 4px 20px rgba(255,107,53,0.35)',
          }}
        >
          <RefreshCw size={17} />
          {t.tryAgain}
        </button>

        {/* Текст ошибки — мелким, для диагностики: юзер может прислать его
            в поддержку, даже не имея доступа к консоли браузера. */}
        {error?.message && (
          <p style={{
            marginTop: 18, fontSize: 10.5, color: '#4A4A4D',
            lineHeight: 1.5, wordBreak: 'break-word', maxWidth: 300,
          }}>
            {String(error.message)}
          </p>
        )}
      </div>
    </div>
  )
}
